import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";


export function GuideQuizDialog({ slug, onClose, onPassed }) {
  const [quiz, setQuiz] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/training/${slug}/quiz`).then((r) => { setQuiz(r.data); setAnswers(r.data.questions.map(() => null)); })
      .catch((err) => { toast.error(apiError(err)); onClose(); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);
  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/training/${slug}/quiz`, { answers });
      setResult(r.data);
      if (r.data.passed) {
        toast.success(r.data.certificate_sent ? "Passed! All guides done — your certificate is on its way" : "Passed — guide marked as read");
        onPassed(r.data.read_at);
      }
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  const retry = () => { setResult(null); setAnswers(quiz.questions.map(() => null)); };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="guide-quiz-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="font-serif">Quick check · {quiz?.title || "Guide"}</DialogTitle></DialogHeader>
        {!quiz ? <div className="text-sm text-slate-400">Loading…</div> : result?.passed ? (
          <div className="text-sm text-emerald-700" data-testid="guide-quiz-passed">{result.total} / {result.total} — well done! This guide is now marked as read.
            <Button className="w-full mt-4 rounded-full ns-btn-primary" onClick={onClose} data-testid="guide-quiz-close">Close</Button></div>
        ) : (
          <div className="space-y-4">
            <p className="text-xs text-slate-500">Answer every question correctly to mark this guide as read. You can retry as often as you like.</p>
            {quiz.questions.map((q, i) => (
              <div key={i} data-testid={`guide-quiz-q-${i}`}>
                <div className={`text-sm font-medium mb-1.5 ${result?.wrong?.includes(i) ? "text-rose-700" : ""}`}>{i + 1}. {q.q}</div>
                <div className="space-y-1">
                  {q.options.map((o, j) => (
                    <label key={j} className={`flex items-center gap-2 text-sm rounded-lg border px-3 py-2 cursor-pointer transition-colors ${answers[i] === j ? "border-teal-600 bg-teal-50" : "border-slate-100 hover:bg-slate-50"}`}>
                      <input type="radio" name={`q${i}`} checked={answers[i] === j} disabled={!!result}
                        onChange={() => setAnswers(answers.map((a, k) => (k === i ? j : a)))} data-testid={`guide-quiz-q-${i}-opt-${j}`} />
                      {o}
                    </label>
                  ))}
                </div>
              </div>
            ))}
            {result && !result.passed && (
              <div className="text-sm text-rose-700" data-testid="guide-quiz-failed">{result.correct} / {result.total} correct — the red questions need another look.</div>
            )}
            {result && !result.passed ? (
              <Button variant="outline" className="w-full rounded-full" onClick={retry} data-testid="guide-quiz-retry">Try again</Button>
            ) : (
              <Button className="w-full rounded-full ns-btn-primary" disabled={busy || answers.some((a) => a === null)} onClick={submit} data-testid="guide-quiz-submit">
                {busy ? "Checking…" : "Submit answers"}
              </Button>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
